import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { OutgoAggregateResult } from 'types';
import DEFAULT_OPTION from './default_option';

type OutgoAggregationResponse = {
  outgo_aggregate_results: OutgoAggregateResult[];
};

const getOutgoAggregations = async (
  kind: string,
  startDate: string,
  endDate: string,
): Promise<OutgoAggregationResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    searchParams: { kind, start_date: startDate, end_date: endDate },
    throwHttpErrors: true,
  };

  const response = await ky.get('outgo_aggregations', options);

  return response.json();
};

export default getOutgoAggregations;
